import React, { Component } from 'react'
import Img from 'gatsby-image'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'

class FaqsEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.handleToogle = this.handleToogle.bind(this)
    this.renderFaqs = this.renderFaqs.bind(this)
  }
  componentDidMount() {
    axios.get(`${backendURL}/api/faqs`).then(res => {
      this.setState({
        loading: false,
        faqs: res.data,
      })
      axios
        .get(`${backendURL}/api/banners/page/Faqs`)
        .then(res => {
          const main = res.data.filter(data => data.section === 'Main')
          if (main[0]) {
            this.setState(prevState => {
              return {
                ...prevState,
                loading: false,
                mainImageEn: {
                  title: main[0].title.en,
                  url: main[0].imageEn,
                },
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    })
  }
  handleToogle(e) {
    const { checked: value, id } = e.target
    this.setState({
      [id]: value,
    })
  }
  renderFaqs() {
    const { faqs } = this.state
    return _.map(faqs, (faq, i) => {
      const { title, description, published } = faq
      const { langKey: lang } = this.props.pathContext
      if (published) {
        const id = `faq${i}`
        return (
          <div className={!this.state[id] ? 'item on' : 'item off'}>
            <input type="checkbox" id={id} onClick={this.handleToogle} />
            <label for={id}>{title[lang]}</label>
            <div className="excerpt">{description[lang]}</div>
          </div>
        )
        return null
      }
    })
  }
  render() {
    if (this.state.loading) {
      return null
    }
    return (
      <div className="page faqs">
            <Helmet
            title={`Budget Nicaragua FAQs`}
            meta={[
              {
                name: 'description',
                content:
                  'Frequently Asked Questions about car rentals.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'en',
                href:
                  './es/faqs',
              },
            ]}
          />
         {this.state.mainImageEn ? (
          <img
            src={`${backendURL}${this.state.mainImageEn.url}`}
            alt={this.state.mainImageEn.title}
            style={{ width: '100%' }}
            className="top-bg"
          />
        ) : (
          <div />
        )}
        <div className="wrapper">
          <h1>FAQ</h1>
         
          <p>
          In Budget Rent a Car we are always at your disposal for any
          doubt or query you have, then some questions and
          answers or if you want to contact us in the icon of
          CONTACT US to consult personally.
          </p>

          <div id="accordion">{this.renderFaqs()}</div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query FAQEnQuery {
    imageSharp(id: { regex: "/faq-top-background/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default FaqsEn



// WEBPACK FOOTER //
// ./src/pages/faqs.en.js